import { render, staticRenderFns } from "./BsButtonToggleField.vue?vue&type=template&id=1dbf8c08&"
import script from "./BsButtonToggleField.vue?vue&type=script&lang=js&"
export * from "./BsButtonToggleField.vue?vue&type=script&lang=js&"
import style0 from "./BsButtonToggleField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports